import Social from './social'

export default Social